import { render, staticRenderFns } from "./lexi.vue?vue&type=template&id=66b48e4d"
import script from "./lexi.vue?vue&type=script&lang=js"
export * from "./lexi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports